<template>
    <v-main class="ml-6 mt-3" style="position: relative;">
        <v-row dense>
            <v-col cols="12">
                <h3>Mapping maintenance</h3>               
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2" class="ml-3 flex">
                <v-icon size="35">mdi-numeric-1-circle-outline</v-icon><selpark @getSelection="setSelPark"/>
            </v-col>
            <v-col cols="4" class="ml-3 flex">
                <v-icon size="35">mdi-numeric-2-circle-outline</v-icon><selunit :selected_park="park" :selected_unit="unit" :selected_acco="acco" @getSelection="setSelUnit"/>
            </v-col>       
            <v-col cols="4" class="ml-3 flex" v-if="needsAttention">                
                <v-icon size="35" color="orange" class="ml-8">mdi-chat-alert</v-icon><div style="margin-left: 10px; font-size: 12pt; font-weight: 400; color: orange;">(This unit needs attention)</div>
            </v-col>     
        </v-row>
        <!-- table goes here -->
        <div class="scrollbar-gutter" style="position:absolute; left: 10px; right: 10px; top: 20%; bottom: 9%;" :class="{'font-md': screensize==='lg', 'font-lg': screensize==='xl',}">
            <div class="grid gridheader scrollbar-gutter">
                <div class="gridheadercol qcol pl-1">Code</div>
                <div class="gridheadercol qcol" >Park cost description</div>
                <div class="gridheadercol qcol number" >Price</div>
                <div class="gridheadercol qcol" >Unit</div>
                <div class="gridheadercol qcol flex-col">Mandatory</div>
                <div class="gridheadercol flex-col gridborderleft">Active</div>
                <div class="gridheadercol flex-col">Amount</div>
                <div class="gridheadercol">VfY cost code</div>
                <div class="gridheadercol"/>
                <div class="gridheadercol"/>
                <div class="gridheadercol">VfY cost description</div>
                <div class="gridheadercol number">Price</div>
                <div class="gridheadercol">Unit</div>
                <div class="gridheadercol"/>
            </div>
            <ul class="scrollbar-gutter">
                <li v-for="(map, idx) in mapping" :key="idx" class="grid">         
                    <div class="gridcol qcol pl-1" :class="{'warning': isCombination(map)}">{{ map.qennercode }}</div>
                    <div class="gridcol qcol" >
                        <div v-if="isDeletedQenner(map)" style="font-weight: 800; color: red;">{{ map.description }}</div>
                        <div v-else>{{ map.description }}</div>
                    </div>
                    <div class="gridcol qcol number" >{{ map.price }}</div>
                    <div class="gridcol qcol" >{{ map.priceunit }}</div>
                    <div class="gridcol qcol flex-col" ><v-simple-checkbox dense :disabled="true" v-model="map.mandatory"></v-simple-checkbox></div>
                    <div class="gridcol gridborderleft">
                        <div class="flex-col">
                            <v-simple-checkbox dense color="blue" v-model="map.active"></v-simple-checkbox>
                        </div>
                    </div>
                    <div class="gridcol flex-col"><v-simple-checkbox dense color="blue" v-model="map.checkamount"></v-simple-checkbox></div>
                    <div class="gridcol">{{ map.arescode }}</div>
                    <div class="gridcol">
                        <v-icon v-if="map.source==='DB'" :color="getDatabaseIconColor(map)">{{ getDatabaseIcon(map) }}</v-icon>
                        <v-icon v-else color="warning">mdi-code-json</v-icon>
                    </div>
                    <div class="gridcol"><v-icon @click="link(map)">mdi-link-variant</v-icon></div>
                    <div class="gridcol">
                        <div v-if="isDeletedVfY(map)" style="font-weight: 800; color: red;">{{ map.aresdescription }}</div>
                        <div v-else>{{ map.aresdescription }}</div>
                    </div>
                    <div class="gridcol number">{{ map.aresprice }}</div>
                    <div class="gridcol" >{{ map.arespriceunit }}</div>
                    <div class="gridcol">
                        <div class="flex-row">
                            <v-icon :class="{'mr-4': screensize==='lg', 'mr-8': screensize==='xl'}" @click="unLink(map)">mdi-link-variant-off</v-icon>
                            <v-icon color="red" @click="deleteLine(idx)">mdi-close</v-icon>                    
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div style="position:absolute; left: 10px; right: 10px; bottom: 3%;" class="number">
                <v-spacer></v-spacer> 
                <div v-if="mappingChanged"><v-icon color="orange" size="35">mdi-database-alert-outline</v-icon><span style="margin-left: 10px; margin-right: 20px; font-size: 16pt; font-weight: 600; color: orange">Mapping has unsaved changes</span></div>             
                <v-btn @click="getMapping()" color="primary" class="mr-4">
                    <v-icon class="mr-2">mdi-undo</v-icon>undo
                </v-btn>                  
                <v-btn @click="saveMapping()" color="success">
                    save changes
                </v-btn>
        </div>        
        <navBar title="Ares - Purchase partners" :home="true" type="pp"/>
        <connectkstp ref="connectkstp" @use="saveLink"/>
    </v-main>
</template>

<script>
    
    import navBar from "@/components/ui/navbars/navbar.vue";
    import selpark from '@/components/ui/selectors/select_parc.vue';
    import selunit from '@/components/ui/selectors/select_park_unit.vue';
    import connectkstp from '@/views/task/pp/connect_kstp.vue';

    export default {
        components: {
            navBar,
            selpark,
            selunit,
            connectkstp
        },
        watch:{
            unit: {            
                handler(v){
                    this.unit=v
                    this.getMapping()
                } 
            },   
            park: {            
                handler(v){
                    this.park=v
                    this.unit=''                  
                    this.getMapping()
                } 
            },    
            mapping: {
                deep: true,
                handler(){
                   JSON.stringify(this.mapping)!==JSON.stringify(this.mapping_org)?this.mappingChanged=true:this.mappingChanged=false
                } 
            },                                
        },           
        data() {
            return {
                park: '',
                unit: '',
                acco: '',
                mapping: [],
                mapping_org: [],
                hpbk: [],
                hasUnsavedOccurences: false,
                needsAttention: false,
                mappingChanged: false,
            }
        },        
        computed: {
            screensize: function () {                
                console.log(this.$vuetify.breakpoint.name)
                return this.$vuetify.breakpoint.name;
            },
        },                    
        methods: {
            getDatabaseIcon(map) {
                return map.aresdescription.indexOf('DELETED')!==-1||map.description.indexOf('DELETED')!==-1?'mdi-database-remove-outline':'mdi-database-check-outline'
            },
            getDatabaseIconColor(map) {
                return map.aresdescription.indexOf('DELETED')!==-1||map.description.indexOf('DELETED')!==-1?'error':'success'
            },
            isDeletedVfY(map) {
                return map.aresdescription.indexOf('DELETED')!==-1?true:false
            },
            isDeletedQenner(map) {
                return map.description.indexOf('DELETED')!==-1?true:false
            },            
            setSelPark(v){
                this.park=v;
            },
            setSelUnit(v){
                console.log('setSelUnit', v)
                if(v.length!==0){
                    this.unit=v[0].value;
                    this.acco=v[1].value;
                } else{
                    this.unit = ''
                    this.acco = ''    
                }
            }, 
            unLink(map){
                map.arescode = null 
                map.aresdescription = ''
                map.checkamount = false
                map.aresprice = ''
                map.arespriceunit = ''
                if(!map.mandatory) map.active = false
            },
            deleteLine(idx){            
                this.mapping.splice(idx, 1)
            },
            link(map) {
                this.$refs.connectkstp.open(map, this.hpbk);
            },
            isCombination(map){
                return map.combination;
            },
            saveLink(_map){
                this.mapping.forEach(el => { // dit moet altijd
                    if(el.index === _map.index) { 
                        el.active = _map.sel_active 
                        el.checkamount = _map.sel_checkamount
                        if (_map.sel_hpbk.length >= 1){
                            el.arescode = _map.sel_hpbk[0].arescode 
                            el.aresdescription = _map.sel_hpbk[0].aresdescription
                            el.aresprice = _map.sel_hpbk[0].sales 
                            el.arespriceunit = _map.sel_hpbk[0].unit
                            if (_map.sel_hpbk.length === 2){ // create combination if needed
                                el.combination = true
                                el.restrictedcode = _map.sel_hpbk[1].arescode
                            }
                        }                            
                    }                        
                }) 
                // dit moet als je meerdere hpbk hebt geselecteerd
                if (_map.sel_hpbk.length === 2){
                    // meerdere hpbk geselcteerd, dus map aanmaken via json.parse(json.stringify())
                    let xmap = new Object()
                    this.mapping.forEach(el => {
                        if(el.index === _map.index) {
                            xmap = JSON.parse(JSON.stringify(el)) // trick to copy object and not just assign a object pointer to a new object pointer (retaining the original object and not creating an new one)
                            xmap.index = this.mapping.length + 1
                            xmap.active = _map.sel_active 
                            xmap.checkamount = _map.sel_checkamount
                            xmap.arescode = _map.sel_hpbk[1].arescode 
                            xmap.aresdescription = _map.sel_hpbk[1].aresdescription
                            xmap.aresprice = _map.sel_hpbk[1].sales 
                            xmap.arespriceunit = _map.sel_hpbk[1].unit
                            xmap.combination = true
                            xmap.restrictedcode = _map.sel_hpbk[0].arescode
                            this.mapping.push(xmap)
                        }    
                    })    
                } 
            },
            saveMapping(){
                this.$axios
                    .post("ares/json/ares/task/pp/saveUnitMappingv2.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "saveUnitMapping"
                        },
                        saveUnitMapping: {
                            unit: this.unit,
                            park: this.park,
                            mapping: this.mapping
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            this.showDialog('error', 'Error', res.data.error.message);
                        } else {
                            this.getMapping("keep")
                        }  
                    }) 
            },
            getMapping(v){

                if(v!=='keep') this.mapping=[]
                this.hpbk=[]

                if(this.park===''||this.unit==='') return

                this.$axios
                    .post("ares/json/ares/task/pp/getUnitMappingv2.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getUnitMapping"
                        },
                        getUnitMapping: {
                            unit: this.unit,
                            park: this.park,
                            acco: this.acco
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            this.showDialog('error', 'Error', res.data.error.message);
                        } else {
                            this.mapping = res.data.getUnitMapping.info
                            this.hpbk = res.data.getUnitMapping.hpbk
                            this.needsAttention = false
                            this.hasUnsavedOccurences = false
                            this.mapping.forEach((el) => {
                                if(el.source==='JSON') this.hasUnsavedOccurences = true
                                if(el.issue) this.needsAttention = true
                            })    
                            this.mapping_org = JSON.parse(JSON.stringify(this.mapping)) // deep copy (not a reference, two different objects)
                        }
                    })                
            }            
        }
    }    
</script>

<style scoped>
.flex{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.flex-row{
    display: flex;
    flex-direction: row;
    align-items: baseline;
}
.flex-col{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
}
.grid{
    display: grid; 
    grid-template-columns: 100px 300px 80px 130px 100px  1fr 1fr 2fr 0.8fr 0.8fr 2fr 1fr 1.5fr 1fr; 
}
.gridheader{
    font-weight: 600;
    border-color: rgb(179, 177, 177);
}
.gridborderleft{
    border-left: 2px solid;
    border-color: rgb(179, 177, 177);
    border-collapse: collapse !important;
}
ul{
    list-style-type: none;
    padding: 0;
    margin: 0;
    height: 90%;
    overflow-y:auto;
}    
.no-scrollbar{
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.gridcol{    
    padding: 4px;
    border-bottom: 1px solid;
    border-color: lightgray;
}
.gridheadercol{    
    padding: 4px;
    border-bottom: 2px solid;
    border-color: lightgray;
}
.qcol{
    background-color: whitesmoke;
}
.number {
    display: flex;
    flex-direction: row; 
    justify-content: flex-end;
    padding-right: 20px !important;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}

.scrollbar-gutter {
  overflow-y: auto;
  scrollbar-gutter: stable;
}

.font-lg{
    font-size:medium;
}
.font-md{
    font-size:smaller;
}
.warning{    
    background-color: rgba(255,195,77, 0.3) !important;
    border-color: lightgray !important;
    font-weight: 600;
}
</style>